<template>
  <v-app style="background-color: #F3F3F3;">
    <v-overlay :value="loading" class="align-center justify-center" z-index="9999">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <Sidebar v-if="showSidebar" @menu-action="handleMenuAction" />

    <v-main>
      <div v-if="bloqueado && showSidebar" class="bloqueio-bar">
        <v-icon color="white" class="mr-2">mdi-alert-octagon</v-icon>
        <span class="bloqueio-text">
          Seus serviços foram bloqueados por falta de pagamento<template v-if="dataBloqueio"> em {{ dataBloqueio
          }}</template>. Regularize as faturas em aberto para reativá-los.
        </span>
        <v-spacer></v-spacer>
        <v-btn small color="white" class="red--text text--darken-3 font-weight-bold ml-2" @click="irParaFaturas">
          <v-icon left small>mdi-file-document-outline</v-icon>
          Ver faturas
        </v-btn>
      </div>

      <router-view ref="routerView"></router-view>
    </v-main>

    <!-- Suporte: bloquear/desbloquear painel (Ctrl+Alt+B) -->
    <v-dialog v-model="dialogBloqueio" max-width="440px" persistent>
      <v-card>
        <v-card-title :class="bloqueado ? 'success white--text' : 'error white--text'">
          <v-icon left color="white">{{ bloqueado ? 'mdi-lock-open-variant' : 'mdi-lock' }}</v-icon>
          <span class="headline">{{ bloqueado ? 'Desbloquear painel' : 'Bloquear painel' }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogBloqueio = false" :disabled="togglingBloqueio">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <p class="text-body-1 mb-2">
            <v-icon small left>mdi-shield-account</v-icon>
            Ação restrita ao suporte.
          </p>
          <p class="text-body-1 mb-0">
            Este painel está <strong>{{ bloqueado ? 'BLOQUEADO' : 'ATIVO' }}</strong>.
            Deseja {{ bloqueado ? 'desbloqueá-lo' : 'bloqueá-lo' }}?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogBloqueio = false" :disabled="togglingBloqueio">
            Cancelar
          </v-btn>
          <v-btn :color="bloqueado ? 'success' : 'error'" :loading="togglingBloqueio" @click="alternarBloqueio">
            <v-icon left>{{ bloqueado ? 'mdi-lock-open-variant' : 'mdi-lock' }}</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Sidebar from './components/layout/Sidebar.vue'
import { alternarBloqueioPainel } from './services/api'

export default {
  name: "App",
  components: {
    Sidebar
  },
  data() {
    return {
      loading: false,
      bloqueado: false,
      block: null,
      dialogBloqueio: false,
      togglingBloqueio: false,
    }
  },
  computed: {
    showSidebar() {
      return this.$route.name !== 'Auth'
    },
    dataBloqueio() {
      if (!this.block) {
        return ''
      }
      const data = new Date(this.block)
      if (isNaN(data.getTime())) {
        return ''
      }
      return data.toLocaleString('pt-br', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }
  },
  watch: {
    '$route.name'() {
      this.verificarBloqueio()
    }
  },
  methods: {
    handleMenuAction(action) {
      const dashboardComponent = this.$refs.routerView?.$children?.[0]
      if (dashboardComponent && typeof dashboardComponent[action] === 'function') {
        dashboardComponent[action]()
      }
    },
    setGlobalLoading(value) {
      this.loading = value
    },
    verificarBloqueio() {
      if (this.$route.name === 'Auth') {
        this.bloqueado = false
        this.block = null
        return
      }
      this.block = localStorage.getItem('block')
      this.bloqueado = !!this.block
    },
    irParaFaturas() {
      const asaasIdRevenda = localStorage.getItem('asaas_id_revenda') || ''
      if (!asaasIdRevenda) {
        return
      }
      const targetPath = `/faturas/${asaasIdRevenda}`
      if (this.$route.path !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    handleAtalhoBloqueio(event) {
      if (!(event.ctrlKey && event.altKey && !event.shiftKey && event.code === 'KeyB')) {
        return
      }
      if (this.$route.name === 'Auth' || !localStorage.getItem('token')) {
        return
      }
      event.preventDefault()
      this.verificarBloqueio()
      this.dialogBloqueio = true
    },
    alternarBloqueio() {
      const token = localStorage.getItem('token')
      if (!token) {
        return
      }
      this.togglingBloqueio = true
      alternarBloqueioPainel(token)
        .then((response) => {
          const block = response?.data?.data?.block
          if (block) {
            localStorage.setItem('block', block)
          } else {
            localStorage.removeItem('block')
          }
          this.togglingBloqueio = false
          this.dialogBloqueio = false
          this.verificarBloqueio()
        })
        .catch(() => {
          this.togglingBloqueio = false
          this.dialogBloqueio = false
        })
    }
  },
  created() {
    this.$root.$on('global-loading', this.setGlobalLoading)

    this.verificarBloqueio()

    if (this.isDesenvolvimento) {
      return;
    }

    if (!this.isRevenda) {
      return;
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleAtalhoBloqueio)
  },
  beforeDestroy() {
    this.$root.$off('global-loading', this.setGlobalLoading)
    window.removeEventListener('keydown', this.handleAtalhoBloqueio)
  }
};
</script>

<style>
body {
  background-color: #F3F3F3;
}

.bloqueio-bar {
  position: sticky;
  top: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  background-color: #c62828;
  color: #fff;
  padding: 10px 16px;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  margin-bottom: 15px;
}

.bloqueio-text {
  line-height: 1.3;
}
</style>
